import { GetAllM24EmessiFiltersDTO, GetAllM24EmessiResponseData } from "./dto";
import { MonitoringM24EmessiImpl } from "./serviceImpl";

export interface MonitoringM24EmessiService {
    GetAllM24Emessi(filters: GetAllM24EmessiFiltersDTO): Promise<GetAllM24EmessiResponseData[]>
}

export function NewMonitoringM24EmessiService(): MonitoringM24EmessiService {
    return new MonitoringM24EmessiImpl()
}